/**
 * Registry of pending-save flushers for open editors (document/presentation).
 *
 * Editors register a flush function while mounted. The chat send path calls
 * flushEditorSaves() right before emitting a user message so that AI
 * revisions run against the user's latest edits instead of a stale draft
 * still sitting in an autosave debounce window.
 *
 * Leaf module: no store/api imports, safe to require from lib/socket.js and
 * from editor components.
 */
const flushers = new Map();

export function registerEditorSaveFlush(key, flushFn) {
  flushers.set(key, flushFn);
  return () => {
    if (flushers.get(key) === flushFn) flushers.delete(key);
  };
}

export function flushEditorSaves() {
  const pending = [];
  for (const flushFn of flushers.values()) {
    try {
      const result = flushFn();
      if (result && typeof result.then === 'function') {
        pending.push(result.catch(() => false));
      } else if (result === false) {
        pending.push(Promise.resolve(false));
      }
    } catch (_) {
      // A failing flusher must never block message sending.
      pending.push(Promise.resolve(false));
    }
  }
  return Promise.all(pending);
}
